import { Icons } from "./icons";

const { shuffleArray } = require("../utils/common");

const Tables = {

  l5: [

    {
      table: [
        ["W9", "W11", "W13"],
        ["W10", "W12", "W14"]
      ],
      title: "L-BLENDS"
    },

  ],
  l6: [
    {
      table: [
        ["W1", "W4", "W6"],
        ["W2", "W5", "W7"],
        ["W3", null, "W8"]
      ],
      title: "R-BLENDS"
    },

  ],
  l7: [

    {
      table: [
        ["W15", "W17", "W19", "W21"],
        ["W16", "W18", "W20", "W22"]
      ],
      title: "S-BLENDS"
    },

  ],
  l8: [

    {
      table: [
        ["W23", "W27", "W29"],
        ["W24", "W28", "W30"],
        ["W25", null, "W31"],
        ["W26", null, "W32"]
      ],
      title: "Mixed-BLENDS"
    }
  ],
  l5p1: [
    ["W1", "W2", "W3", "W4", "W5", "W6"],
    ["W7", "W8", "W9", "W10", "W11", "W12"],
    ["W13", "W14", "W15", "W16", "W17", "W18"],
    ["W19", "W20", "W21", "W22", "W23", "W24"],
  ],
  l5p2: [
    ["T1", "T2", "T3", "T4", "T5", "T6"],
    ["T7", "T8", "T9", "T10", "T11", "T12"],
    ["T13", "T14", "T15", "T16", "T17", "T18"],
    ["T19", "T20", "T21", "T22", "T23", "T24"],
  ],
  // l6: [
  //   {
  //     table: [
  //       ["W1", "W4", "W6"],
  //       ["W2", "W5", "W7"],
  //       ["W3", null, "W8"]
  //     ],
  //     title: "R-BLENDS"
  //   },
  //   {
  //     table: [
  //       ["W9", "W11", "W13"],
  //       ["W10", "W12", "W14"]
  //     ],
  //     title: "L-BLENDS"
  //   },
  //   {
  //     table: [
  //       ["W15", "W17", "W19", "W21"],
  //       ["W16", "W18", "W20", "W22"]
  //     ],
  //     title: "S-BLENDS"
  //   },
  //   {
  //     table: [
  //       ["W23", "W27", "W29"],
  //       ["W24", "W28", "W30"],
  //       ["W25", null, "W31"],
  //       ["W26", null, "W32"]
  //     ],
  //     title: "Mixed-BLENDS"
  //   }
  // ],
  l13: [
    {
      table: [
        ["W1", "W4", "W6"],
        ["W2", "W5", "W7"],
        ["W3", "W8", "W9"]
      ],
      title: "Vowel Combinations",
    },

  ],
  l14: [

    {
      table: [
        ["W10", "W11", "W12"],
        ["W13", "W14", "W15"],
        ["W16", "W17", "W18"]
      ],
      title: "Vowel Combinations"
    },

  ],
  l15: [

    {
      table: [
        ["W19", "W20", "W21"],
        ["W22", "W23", "W24"],
        ["W25", "W26", "W27"]
      ],
      title: "Vowel Combinations"
    }
  ],
  l16: [
    {
      table: [
        ["W1", "W5", "W9"],
        ["W2", "W6", "W10"],
        ["W3", "W7", "W11"],

      ],
      title: "Vowel/Consonant Blends"
    },

  ],
  l17: [

    {
      table: [
        ["W4", "W8", "W12"],
        ["W21", "W24", "W26"],
        ["W22", "W25", "W27"],
        [null, null, "W28"]

      ],
      title: "Vowel/Consonant Blends"
    },

  ],
  l18: [

    {
      table: [
        ["W13", "W16", "W19"],
        ["W14", "W17", "W20"],
        ["W15", "W18", null]
      ],
      title: "Vowel/Consonant Blends"
    }
  ],
  l20: [
    ["W1", "W5", "W9"],
    ["W2", "W6", "W10"],
    ["W3", "W13", "W11"],
    ["W4", "W8", "W12"]


  ],
  l21: [
    ["W7", "W17", "W21"],
    ["W14", "W18", "W22"],
    ["W15", "W19", "W23"],
    ["W16", "W20", null]


  ],
  l22: [
    ["W1", "W6", "W11"],
    ["W2", "W7", "W12"],
    ["W3", "W8", "W13"],
    ["W4", "W9", "W14"],
    ["W5", "W10", "W15"]

  ],
  l23: [
    ["W16", "W21", null],
    ["W17", "W22", "W27"],
    ["W18", "W23", "W28"],
    ["W19", "W24", "W29"],
    ["W20", "W25", "W30"]

  ],
  l24: [
    {
      table: ["W1", "W2", "W3", "W4", "W5", "W6", "W7", "W8"],
      title: "Group 1",
    },
    {
      table: ["W9", "W10", "W11", "W12", "W13", "W14", "W15", "W16"],
      title: "Group 2",
    },
    {
      table: ["W17", "W18", "W19", "W20", "W40"],
      title: "Group 3",
    },
  ],
  l25: [
    {
      table: ["R1", "R2", "R3", "R4", "R5", "R6", "R7", "R8"],
      title: "Group 4",
    },
    {
      table: ["R9", "R11", "R12", "R13", "R14", "R15", "R16"],
      title: "Group 5",
    },
    {
      table: ["R17", "R18", "R19"],
      title: "Group 6",
    },
  ],
  l18Repeat: [
    {
      table: ["X1", "X2", "X3", "X4", "X5", "X6", "X7", "X8"],
      title: "Group 4",
    },
    {
      table: ["X9", "X11", "X12", "X13", "X14", "X15", "X16"],
      title: "Group 5",
    },
    {
      table: ["X17", "X18", "X19"],
      title: "Group 6",
    },
  ],
}

export const Lessons = {
  default: {
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/audios/chimes/{{key}}.mp3",
          data: [
            "bell",
            "drag",
            "drop",
            "click",
            "coin",
            "correct",
            "failure",
            "notifications",
            "processing",
            "recording",
            "success",
            "wrong",
            "twinkle"
          ],
        },
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/audios/repeatables/{{key}}.mp3",
          prefix: "repeatables/",
          data: [
            "word",
            "mic-pr",
            "select",
            "word",
            "word2",
            "L1",
            "L2",
            "L2-1",
            "L3-GP1",
            "L3-GP2",
            "L3-P1",
            "L3-P2",
            "L4-P1",
            "L4-P2",
            "L4-P3",
            "L5-P1",
            "L6-CB",
            "L6-GP",
            "L7-P1",
            "L7-P2",
            "L7-P3",
            "L8-P1",
            "L8-VC",
            "L9-P1",
            "L9-P2",
            "L9-P3",
            "L10-P1",
            "L10-VC",
            "L11-P1",
            "L11-P2",
            "L11-P3",
            "L12-P1",
            "L12-P2",
            "L13-P1",
            "L13-P2",
            "L14-P1",
            "L14-P2",
            "L14-P3",
            "L15-P1",
            "L15-P2",
            "L16-P1",
            "L16-P2",
            "L16-P3",
            "L17-P1",
            "L17-P2",
            "L18-GP",
            "L18-P1",
            "L19",
            "L20",
            "L21"
          ]
        },
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/audios/endings/{{key}}.mp3",
          prefix: "endings/",
          data: [
            "avfail",
            "l1fail",
            "l1pass",
            "l2fail",
            "l2pass",
            "l3fail",
            "l3pass",
            "l4fail",
            "l4pass",
            "l5fail",
            "l5pass",
            "l6fail",
            "l6pass",
            "l7fail",
            "l7pass",
            "l8fail",
            "l8pass",
            "l9fail",
            "l9pass",
            "l10fail",
            "l10pass",
            "l11fail",
            "l11pass",
            "l12fail",
            "l12pass",
            "l13fail",
            "l13pass",
            "l14fail",
            "l14pass",
            "l15fail",
            "l15pass",
            "l16fail",
            "l16pass",
            "l17fail",
            "l17pass",
            "l18fail",
            "l18pass",
            "l19fail",
            "l19pass",
            "l20fail",
            "l20pass",
            "l21",
            "l22fail",
            "l22pass",
            "l23fail",
            "l23pass",
            "l24fail",
            "l24pass",
            "l25fail",
            "l25pass",
            "l26fail",
            "l26pass",
            "l27fail",
            "l27pass",
            "l28fail",
            "l28pass"
          ]
        },
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/audios/review/{{key}}.mp3",
          prefix: "review/",
          data: ["review", "review2", "reviewlesson"]
        },
        {
          "audio":
            "https://read21-assets.s3.amazonaws.com/fl/mod/3/{{key}}.mp3",
          "prefix": "mod/",
          data: ["3a", "3b", "3c", "3d", "3e", "3f", "3g"]
        },
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/audios/misc/{{key}}.mp3",
          data: ["ambience", "enticing", "plustrain"],
        },
      ],
      wrong: {
        audio:
          "https://d3vx0tne0vxeo1.cloudfront.net/audios/prompts/wrong/{{key}}.mp3",
        data: [1, 2, 3, 4],
        flow: "random"
      },
      empty: {
        audio:
          "https://d3vx0tne0vxeo1.cloudfront.net/audios/prompts/empty/{{key}}.mp3",
        data: [1, 2, 3, 4],
        flow: "random"
      },
      correct: {
        audio:
          "https://d3vx0tne0vxeo1.cloudfront.net/audios/prompts/correct/{{key}}.mp3",
        data: [1, 2, 3, 4, 5, 6, 7],
        flow: "random"
      },
      introduction:
        "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/introduction.mp3",
      introductionMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/introduction.mp3",
      selectMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/select.mp3",
      micMobile: {
        audio:
          "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/{{key}}.mp3",
        data: ["mic-l", "mic-r", "mic-s", "mic-mx", "mic-v", "mic-vcc"]
      },
      gpMobile: {
        audio:
          "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/{{key}}.mp3",
        data: ["gp-l", "gp-r", "gp-s", "gp-mx", "gp-vcx", "gp-vc", "gp-vcc"]
      },
      gpL: {
        audio:
          "https://read21-assets.s3.us-east-1.amazonaws.com/audios/lesson/{{lessonId}}/mobile/prompts/gp-{{key}}.mp3",
        data: [
          "flip",
          "clamp",
          "blob",
          "plug",
          "press",
          "crab",
          "tree",
          "grip",
          "slug",
          "smell",
          "snort",
          "shrink",
          "thrill",
          "ship",
          "whale",
          "thing",
          "maid",
          "seize",
          "prey",
          "pause",
          "dew",
          "broil",
          "droop",
          "mouse",
          "test",
          "soap",
          "spent",
          "stir",
          "sect",
          "tact",
          "rail",
          "hound",
          "stuck",
          "shrimp",
          "chuck",
          "tale",
          "soft",
          "look",
          "meal",
          "steel"
        ]
      },
      cbpractMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/cbpract.mp3",
      roiMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/rio.mp3",
      s2wordsMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/s2words.mp3",
      micstghtwordsMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/mic-sightwords.mp3",
      vcomboMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/vcombo.mp3",
      vcpractMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/vcpract.mp3",
      vccpractMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/vccpract.mp3",
      vconMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/vcon.mp3",
      selectvccMobile:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/mobile/prompts/select-vcc.mp3",
      example:
        "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/example.mp3",
      explanation:
        "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/explanation.mp3",
      letsbegin:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/prompts/letsbegin.wav",
      tooloud:
        "https://d3vx0tne0vxeo1.cloudfront.net/audios/prompts/tooloud.mp3",
    }
  },

  0: {
    stages: {
      microphone: {
        type: "DisplayItems",
        subType: "largeWord",
        playBefore: true,
        microphone: true,
        micDisabled: true,
        startImmediately: true,
        silenceBuzz: true,
        delayBefore: 2500,
        steps: [
          {
            type: "audio",
            content: "repeatables/mic-pr",
            afterDelay: 1000
          },
        ],
        title: "Working the Mic",
        instruction: "repeatables/mic-pr",
        introduction: {
          title: "Working the Mic",
          subTitle: "Training",
          videoPresentation: "https://d3vx0tne0vxeo1.cloudfront.net/videos/microphone.mp4"
        }
      },
      p1: {
        type: "DisplayItems",
        subType: "letterSound",
        silenceBuzz: true,
        microphone: true,
        micDisabled: false,
        delayBefore: 3000,
        // timeOut: 500000,
        // startImmediately: true,
        countDown: false,
        steps: [
          {
            type: "countShowDown",
            content: 10
          },

          {
            type: "rawDisplay",
            content: Icons.pretestIntroduction,
            afterDelay: 500
          },
          {
            type: "audio",
            content: "prompt/ptinfo",
            wBegin: true
          },
          {
            type: "setTitle",
            content: "Part 1"
          },
          {
            type: "rawDisplay",
            content: Icons.p1Introduction,
          },
          {
            type: "audio",
            content: "p1/introductory",
            wBegin: true
          }
        ],
        introduction: {
          title: "Part 1",
          subTitle: "Pre-Test",
          // audio: "prompt/e-1"
        }
      },
      // P5 Changed position to P2
      p5: {
        type: "DisplayItems",
        subType: "word",
        silenceBuzz: true,
        microphone: true,
        micDisabled: false,
        delayBefore: 3000,
        // startImmediately: true,
        countDown: true,
        title: "Part 2",
        introduction: {
          title: "Part 2",
          subTitle: "Pre-Test",
          audio: "prompt/e-5"
        }
      },
      p2: {
        type: "InsertText",
        silenceBuzz: true,
        playBefore: true,
        timeOut: 30,
        title: "Part 3",
        steps: [
          {
            type: "video",
            content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/0/intro2/[[ageGroup]].mp4"
          },
        ],
        noItemTitle: true,
        introduction: {
          title: "Part 3",
          subTitle: "Pre-Test",
          // audio: "prompt/e-2"
        }
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        silenceBuzz: true,
        microphone: true,
        micDisabled: true,
        delayBefore: 3000,
        // startImmediately: true,
        countDown: true,
        title: "Part 4",
        introduction: {
          title: "Part 4",
          subTitle: "Pre-Test",
          // audio: "prompt/e-3"
        },
        steps: [
          {
            type: "video",
            content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/0/intro3/[[ageGroup]].mp4"
          },
        ],
        playAfter: {
          audio: "prompt/pass"
        },
      },
      p4: {
        type: "DisplayItems",
        subType: "word",
        silenceBuzz: true,
        microphone: true,
        micDisabled: false,
        delayBefore: 3000,
        // startImmediately: true,
        countDown: true,
        title: "Part 5",
        steps: [
          {
            type: "video",
            content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/0/intro4/[[ageGroup]].mp4"
          },
        ],
        introduction: {
          title: "Part 5",
          subTitle: "Pre-Test",
          // audio: "prompt/e-4"
        }
      },
      reading: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        title: "Reading Check",
        timeOut: 60,
        microPhoneConfig: {
          waitTime: 60000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Reading Check",
          subTitle: "Pre-Test",
          audio: "prompt/reading-intro"
        }
      }
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["e-1", "e-2", "e-3", "e-4", "e-5", "mic-1", "pass", "ptinfo", "reading-intro", "phrase"]
      }, {
        audio: "https://read21-assets.s3.amazonaws.com/fl/0/p1/{{key}}.mp3",
        prefix: "p1/",
        data: ["introductory", ...["y", "a", "e", "n", "p", "l", "b", "o", "d", "u", "w", "g", "j", "i", "z"].map(l => `part1-${l}`)]
      }]
    },
    data: "pretest",
    label: 0,

    noIntroduction: true
  },

  1: {
    stages: {
      alphabets: {
        type: "Colorful",
        subType: "normal",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        silencePrompt: {
          base: "empty",
          flow: "random",
          from: [1, 2, 3, 4]
        },
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        wrongPrompt: {
          base: "wrong",
          flow: "random",
          from: [1, 2, 3, 4]
        },
        title: "Read it Out!",
        instruction: "repeatables/L1"
      }
    },
    audioSets: {},
    data: "alphabets",
    label: 1,

  },

  2: {
    stages: {
      alphabets: {
        type: "Colorful",
        subType: "half",
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        silencePrompt: {
          base: "empty",
          flow: "random",
          from: [1, 2, 3, 4]
        },
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        wrongPrompt: {
          base: "wrong",
          flow: "random",
          from: [1, 2, 3, 4]
        },
        // title: "Read it Out!",
        instruction: "repeatables/L2-1"
      },

      p1: {
        type: "DisplayItems",
        subType: "letterSound",
        silenceBuzz: true,
        microphone: true,
        micDisabled: false,
        guided: true,
        delayBefore: 3000,
        title: "Alphabets",
        // timeOut: 500000,
        // startImmediately: true,
        countDown: false,
        steps: [
          // { type: "countShowDown", content: 10 },
          // {
          //   type: "rawDisplay",
          //   // "content": Icons.pretestIntroduction,
          //   afterDelay: 500
          // },
          // { type: "audio", content: "prompt/ptinfo", wBegin: true },
          { type: "Alphabets", content: "Random order" },
          {
            type: "rawDisplay",
            content: Icons.p1Introduction,
          },
          { type: "audio", content: "p1/introductory", wBegin: true }
        ],
        // introduction: {
        //   title: "Part 1",
        //   subTitle: "Alphabets",
        //   // audio: "prompt/e-1"
        // }
      },


    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["e-1", "e-2", "e-3", "e-4", "e-5", "e-6", "e-7", "mic-1", "pass", "ptinfo"]
      }, {
        audio: "https://read21-assets.s3.amazonaws.com/fl/0/p1/{{key}}.mp3",
        prefix: "p1/",
        data: ["introductory", ...["y", "a", "e", "n", "p", "l", "b", "o", "d", "u", "w", "g", "j", "i", "z"].map(l => `part1-${l}`)]
      }]
    },
    data: "lesson2",
    label: 2,

  },

  3: {
    stages: {
      gp1: {
        type: "DisplayItems",
        subType: "images",
        playBefore: true,
        silenceBuzz: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/L3-GP1",
        delayBefore: 2500
      },
      p1: {
        type: "DisplayItems",
        subType: "imagesText",
        playBefore: true,
        silenceBuzz: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/L3-P1",
        img: "https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/3/{{key}}.svg",
        delayBefore: 1000
      },
      gp2: {
        type: "DisplayItems",
        subType: "characters",
        playBefore: true,
        dontPlayStatus: true,
        dontShowStatus: true,
        score: false,
        silenceBuzz: true,
        instruction: "repeatables/L3-GP2",
        flipped: true,
        delayBefore: 1000
      },
      p2: {
        type: "DisplayItems",
        subType: "charImages",
        micDisabled: true,
        silenceBuzz: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 10,
        instruction: "repeatables/L3-P2",
        flipped: true,
        boxed: true,
        delayBefore: 1000,
        img: "https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/3/{{key}}.svg",
      },
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["end", "goodjob", "mod_end", "n1", "n2", "n3_1", "n3", "n4_1", "n4_2", "n4_3", "n4"]
      }],
      "mod": {
        audio: "https://read21-assets.s3.amazonaws.com/fl/mod/{{lessonId}}/{{key}}.mp3",
        prefix: "mod/",
        data: ["3a"]
      }
    },
    data: "lesson3",
    label: 3,

  },
  4: {
    stages: {
      prep: {
        type: "DisplayItems",
        subType: "wordBlend",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 2500,
        steps: [],
        title: "Tap it Out!",
        introduction: {
          title: "Tap it Out!",
          audio: "prompt/prep1"
        }
      },
      p1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        silenceBuzz: true,
        instruction: "repeatables/L4-P1",
        delayBefore: 1000,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        title: "Practice 1",
        introduction: {
          title: "Blending Basics",
          subTitle: "Practice 1",
          audio: "prompt/p1"
        }
      },
      p2: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        silenceBuzz: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/L4-P2",
        delayBefore: 1000,
        title: "Practice 2",
        introduction: {
          title: "Blending Basics",
          subTitle: "Practice 2",
          audio: "prompt/p2"
        }
      },
      p3: {
        type: "InsertText",
        background: {

          type: "contentGrid",
          content: "abcdefghijklmnopqrstuvwxyz".split("")
        },
        silenceBuzz: true,
        instruction: "repeatables/L4-P3",
        delayBefore: 1000,
        title: "Practice 3",
        introduction: {
          title: "Blending Basics",
          subTitle: "Practice 3",
          audio: "prompt/p3"
        },
        inputFlavour: "preInserted"
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        title: "Read it Out!",
        instruction: "repeatables/L20",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio"
        }

      },
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["p1", "p2", "p3_1", "p3", "prep1", "prep2", "prep3", "prep4", "prep5", "prep6", "rio"]
      },
      {
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/chars/{{key}}.mp3",
        prefix: "char/",
        data: ["p", "i", "t"]
      },
      {
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/blend/{{key}}.mp3",
        prefix: "blend/",
        data: [
          "u-select",
          "select",
          "gp-blend-bag1",
          "gp-blend-bag2",
          "gp-blend-bag3",
          "gp-blend-bag4",
          "gp-blend-tag1",
          "gp-blend-tag2",
          "gp-blend-tag3",
          "gp-blend-tag4",
          "gp-blend-rag1",
          "gp-blend-rag2",
          "gp-blend-rag3",
          "gp-blend-rag4",
          "gp-u-blend",
          "l4-ed",
          ...Array.from({ length: 26 }, (_, i) => `l4-${String.fromCharCode(97 + i)}`),
        ]
      }]
    },
    review: {
      fromLesson: "self",
      stages: ["prep"]
    },
    data: "lesson4",
    label: 4,

  },

  //   3: {
  //     stages: {
  //       gp1: {
  //         type: "DisplayImageItems",
  //         subType: "images",
  //         playBefore: true,
  //         silenceBuzz: true,
  //         guided: true,
  //         correctPrompt: {
  //           base: "correct",
  //           flow: "random",
  //           from: [1, 2, 3, 4, 5, 6, 7]
  //         },
  //         title: "Vowel Sounds (Short, Long, & Y)",
  //         instruction: "repeatables/L3-GP1",
  //         delayBefore: 2500
  //       },
  //       p1: {
  //         type: "DisplayImageItems",
  //         subType: "imagesText",
  //         playBefore: true,
  //         silenceBuzz: true,
  //         guided: true,
  //         correctPrompt: {
  //           base: "correct",
  //           flow: "random",
  //           from: [1, 2, 3, 4, 5, 6, 7]
  //         },
  //         title: "Vowel Sounds (Short, Long, & Y)",
  //         instruction: "repeatables/L3-P1",
  //         img:
  //             "https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/3/{{key}}.svg",
  //         delayBefore: 1000
  //       },
  //       gp2: {
  //         type: "DisplayImageItems",
  //         subType: "characters",
  //         playBefore: true,
  //         dontPlayStatus: true,
  //         dontShowStatus: true,
  //         guided: true,
  //         score: false,
  //         silenceBuzz: true,
  //         instruction: "repeatables/L3-GP2",
  //         title: "Vowel Sounds (Short, Long, & Y)",
  //         flipped: true,
  //         delayBefore: 1000
  //       },
  //       p2: {
  //         type: "DisplayImageItems",
  //         subType: "charImages",
  //         micDisabled: true,
  //         silenceBuzz: true,
  //         guided: true,
  //         transition: false,
  //         correctPrompt: {
  //           base: "correct",
  //           flow: "random",
  //           from: [1, 2, 3, 4, 5, 6, 7]
  //         },
  //         title: "Vowel Sounds (Short, Long, & Y)",
  //         timeOut: 10,
  //         instruction: "repeatables/L3-P2",
  //         flipped: true,
  //         boxed: true,
  //         delayBefore: 1000,
  //         img:
  //             "https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/3/{{key}}.svg",
  //       },
  //     },
  //     audioSets: {
  //       _: [
  //         {
  //           audio:
  //               "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/prompts/{{key}}.mp3",
  //           prefix: "prompt/",
  //           data: [
  //             "end",
  //             "goodjob",
  //             "mod_end",
  //             "n1",
  //             "n2",
  //             "n3_1",
  //             "n3",
  //             "n4_1",
  //             "n4_2",
  //             "n4_3",
  //             "n4"
  //           ]
  //         }
  //       ],
  //       "mod": {
  //         audio:
  //             "https://read21-assets.s3.amazonaws.com/fl/mod/{{lessonId}}/{{key}}.mp3",
  //         prefix: "mod/",
  //         data: ["3a"]
  //       }
  //     },
  //     data: "lesson3"
  //   },

  //   4: {
  //     stages: {
  //       prep: {
  //         type: "DisplayItems",
  //         subType: "word",
  //         silenceBuzz: true,
  //         guided: true,
  //         delayBefore: 2500,
  //         steps: [
  //           {type: "display", content: "b-a-g"},
  //           {type: "audio", content: "prompt/prep2", afterDelay: 1000},
  //         ],
  //         title: "Tap it Out!",
  //         introduction: {title: "Tap it Out!", audio: "prompt/prep1"}
  //       },
  //       p1: {
  //         type: "DisplayItems",
  //         subType: "word",
  //         microphone: true,
  //         silenceBuzz: true,
  //         guided: false, 

  //         transition: false,
  //         instruction: "repeatables/L4-P1",
  //         delayBefore: 1000,
  //         title: "Practice 1",
  //         introduction: {
  //           title: "Blending Basics",
  //           subtitle: "Practice 1",
  //           audio: "prompt/p1"
  //         }
  //       },
  //       p2: {
  //         type: "DisplayItems",
  //         subType: "word",
  //         microphone: true,
  //         silenceBuzz: true,
  //         guided: false, 

  //         instruction: "repeatables/L4-P2",
  //         delayBefore: 1000,
  //         title: "Practice 2",
  //         introduction: {
  //           title: "Blending Basics",
  //           subtitle: "Practice 2",
  //           audio: "prompt/p2"
  //         }
  //       },
  //       p3: {
  //         type: "InsertText",
  //         background: {
  //           type: "contentGrid",
  // "content": "abcdefghijklmnopqrstuvwxyz".split("")
  //         },
  //         silenceBuzz: true,
  //         guided: false, 

  //         instruction: "repeatables/L4-P3",
  //         delayBefore: 1000,
  //         title: "Practice 3",
  //         introduction: {
  //           title: "Blending Basics",
  //           subtitle: "Practice 3",
  //           audio: "prompt/p3"
  //         },
  //         inputFlavour: "preInserted"
  //       },
  //       rio: {
  //         type: "ReadItOut",
  //         subType: "sequential",
  //         microphone: true,
  //         silenceBuzz: true,
  //         guided: false, 

  //         delayBefore: 1000,
  //         title: "Read it Out!",
  //         microPhoneConfig: {
  //           waitTime: 35000,
  //           timeOut: 7000,
  //           wrLength: 50
  //         },
  //         playAfter: [
  //           {afterDelay: 1000, audio: "prompt/rio", beforeDelay: 500}
  //         ],
  //         introduction: {title: "Read it Out!", audio: "prompt/rio"}
  //       },
  //     },
  //     audioSets: {
  //       _: [
  //         {
  //           audio:
  //               "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/prompts/{{key}}.mp3",
  //           prefix: "prompt/",
  //           data: [
  //             "p1",
  //             "p2",
  //             "p3_1",
  //             "p3",
  //             "prep1",
  //             "prep2",
  //             "prep3",
  //             "prep4",
  //             "prep5",
  //             "prep6",
  //             "rio"
  //           ]
  //         },
  //         {
  //           audio:
  //               "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/chars/{{key}}.mp3",
  //           prefix: "char/",
  //           data: ["p", "i", "t"]
  //         }
  //       ]
  //     },
  //     review: {
  //       fromLesson: "self",
  //       stages: ["prep"]
  //     },
  //     data: "lesson4"
  //   },

  5: {
    stages: {
      exp: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        guided: true,

        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        table: { type: "multi", data: Tables.l5 },
        delayBefore: 1000,
        uiBeforesteps: true,
        title: "Guided Practice",
        instruction: "repeatables/L6-GP",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectMobile", beforeDelay: 500 }
        // ],
      },
      p1: {
        type: "InsertText",
        background: {
          type: "chaos",
          "content": shuffleArray(Array.from(new Array(6)).map((_, i) => `W${i + 9}`))
        },
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/select",
        delayBefore: 1000,
        title: "L - Blends in Random Order",
        timeOut: 20,
        inputPrefix: "Blend",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        instruction: "prompt/n5",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "L - Blends in Random Order",
        // timeOut: 20,
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-l", beforeDelay: 500 }
        // ],
      },
      prep: {
        type: "DisplayItems",
        subType: "wordBlend",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 2500,
        steps: [],
        title: "Tap it Out!",
        introduction: {
          title: "Tap it Out!",
          audio: "prompt/prep1"
        }
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "flip",
            blue: true,
            color: "fl"
          },
          {
            type: "audio",
            content: "prompt/gp-flip",
            afterDelay: 1000
          },
        ],
        delayBefore: 1000,
        title: "Blending with Consonant Blends.",
        // timeOut: 20,
        introduction: {
          title: "Consonant Blends: Practice",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-l", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        delayBefore: 1000,
        title: "Consonant Blends",
        // timeOut: 20,
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/cbpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "cbpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        instruction: "repeatables/L20",
        title: "Read it Out!",
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
        introduction: { title: "Read it Out!", audio: "prompt/rio" }
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" }
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "select", "mic", "gp", "cbpract", "rio", "prep1", "gp-flip", "gp-clamp", "gp-plug", "gp-blob"]
        },
        {
          // Lesson 5 Tap-it-Out audios, all in lesson 5's own blend directory (bare names).
          // - flip/plug/blob (sync walkthrough): a single gp-blend-<word> file each.
          // - clap/slug/glad (interactive clusterSpread): L-blend onset + vowel + final + rime tap sounds.
          //   (bless/slam tap silently, so they need no extra audio.)
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/blend/{{key}}.mp3",
          prefix: "blend/",
          data: [
            ...["flip", "plug", "blob"].flatMap(
              w => [1, 2, 3, 4].map(i => `gp-blend-${w}${i}`)
            ),
            "u-select", "select", "gp-u-blend",
            "cl", "a", "p", "ap",
            "sl", "u", "g", "ug",
            "gl", "d", "ad",
          ]
        }
      ]
    },
    review: {
      // "fromLesson": "self",
    },
    data: "lesson5",
    label: 5,
    part: "a"
  },

  6: {
    stages: {
      exp: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        table: { type: "multi", data: Tables.l6 },
        delayBefore: 1000,
        uiBeforesteps: true,
        title: "Guided Practice",
        instruction: "repeatables/L6-GP",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectMobile", beforeDelay: 500 }
        // ],
      },
      p1: {
        type: "InsertText",
        background: {
          type: "chaos",
          content: shuffleArray(Array.from(new Array(8)).map((_, i) => `W${i + 1}`))
        },
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/select",
        delayBefore: 1000,
        title: "R - Blends in Random Order",
        timeOut: 20,
        inputPrefix: "Blend",
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "L - Blends in Random Order",
        timeOut: 20,
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-r", beforeDelay: 500 }
        // ],
      },
      prep: {
        type: "DisplayItems",
        subType: "wordBlend",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 2500,
        steps: [],
        title: "Tap it Out!",
        introduction: {
          title: "Tap it Out!",
          audio: "prompt/prep1"
        }
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
 microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "crab",
            blue: true,
            color: "cr"
          },
          {
            type: "audio",
            content: "prompt/gp-crab",
            afterDelay: 1000
          },
        ],
        delayBefore: 1000,
        title: "Blending with Consonant Blends.",
        timeOut: 20,
        introduction: {
          title: "Consonant Blends: Practice",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-r", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        delayBefore: 1000,
        title: "Consonant Blends",
        timeOut: 20,
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/cbpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "cbpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        instruction: "repeatables/L20",
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "select", "mic", "gp", "cbpract", "rio", "prep1", "gp-crab", "gp-tree", "gp-press", "grip-a"]
        },
        {
          // Lesson 6 Tap-it-Out audios, all in lesson 6's own blend directory (bare names).
          // - crab/grip/wren (sync walkthrough): four numbered gp-blend-<word> files each.
          // - press/trot (interactive clusterSpread): R-blend onset + vowel + final + rime tap sounds.
          //   (drip/fret tap silently, so they need no extra audio.)
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/blend/{{key}}.mp3",
          prefix: "blend/",
          data: [
            ...["crab", "grip", "wren"].flatMap(
              w => [1, 2, 3, 4].map(i => `gp-blend-${w}${i}`)
            ),
            "u-select", "select", "gp-u-blend",
            "pr", "e", "ss", "ess",
            "tr", "o", "t", "ot",
          ]
        }
      ]
    },
    review: {
      // "fromLesson": "self",
    },
    data: "lesson6",
    label: 5,
    part: "b"
  },

  7: {
    stages: {
      exp: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        table: { type: "multi", data: Tables.l7 },
        delayBefore: 1000,
        uiBeforesteps: true,
        title: "Guided Practice",
        instruction: "repeatables/L6-GP",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectMobile", beforeDelay: 500 }
        // ],
      },
      p1: {
        type: "InsertText",
        background: {
          type: "chaos",
          content: shuffleArray(Array.from(new Array(8)).map((_, i) => `W${i + 15}`))
        },
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/select",
        delayBefore: 1000,
        title: "S - Blends in Random Order",
        timeOut: 20,
        inputPrefix: "Blend",
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
        playBefore: false,
         microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "S - Blends in Random Order",
        timeOut: 20,
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-s", beforeDelay: 500 }
        // ],
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        delayBefore: 1000,
        steps: [
          {
            type: "display",
            content: "smell",
            blue: true,
            color: "sm"
          },
          {
            type: "audio",
            content: "prompt/gp-smell",
            afterDelay: 1000
          },
        ],
        title: "Blending with Consonant Blends.",
        timeOut: 20,
        introduction: {
          title: "Consonant Blends: Practice",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-s", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        delayBefore: 1000,
        title: "Consonant Blends",
        timeOut: 20,
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/cbpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "cbpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        instruction: "repeatables/L20",
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" }
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "select", "mic", "gp", "cbpract", "rio", "gp-smell", "gp-slug", "gp-snort", "shrink-a"]
        }
      ]
    },
    review: {
      // "fromLesson": "self",
    },
    data: "lesson7",
    label: 6,
    part: "a"
  },

  8: {
    stages: {
      exp: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        table: { type: "multi", data: Tables.l8 },
        delayBefore: 1000,
        uiBeforesteps: true,
        title: "Guided Practice",
        instruction: "repeatables/L6-GP",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectMobile", beforeDelay: 500 }
        // ],
      },
      p1: {
        type: "InsertText",
        background: {
          type: "chaos",
          content: shuffleArray(Array.from(new Array(10)).map((_, i) => `W${i + 23}`))
        },
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/select",
        delayBefore: 1000,
        title: "Mixed - Blends in Random Order",
        timeOut: 20,
        inputPrefix: "Blend",
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
        playBefore: false,
         microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Mixed - Blends in Random Order",
        timeOut: 20,
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-mx", beforeDelay: 500 }
        // ],
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "thrill",
            blue: true,
            color: "thr"
          },
          {
            type: "audio",
            content: "prompt/gp-thrill",
            afterDelay: 1000
          },
        ],
        delayBefore: 1000,
        title: "Blending with Consonant Blends.",
        timeOut: 20,
        introduction: {
          title: "Consonant Blends: Practice",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-mx", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        delayBefore: 1000,
        title: "Consonant Blends",
        timeOut: 20,
        introduction: {
          title: "Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/cbpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "cbpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "select", "mic", "gp", "cbpract", "rio", "gp-thrill", "gp-ship", "gp-whale", "thing-a"]
        }
      ]
    },
    review: {
      // "fromLesson": "self",
    },
    data: "lesson8",
    label: 6,
    part: "b"
  },
 
  9: {
    stages: {
      exp1: {
        type: "DisplayItems",
        subType: "word",
        table: { data: Tables.l5p1, type: "simple" },

        playBefore: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Guided Practice 1",
        instruction: "repeatables/L5-P1",

        // playAfter: [
        //   {
        //     afterDelay: 1000,
        //     audio: "micstghtwordsMobile",
        //     beforeDelay: 500
        //   }
        // ],
      },
      p1: {
        type: "DisplayItems",
        subType: "word",
        table: { data: Tables.l5p1, type: "simple" },
        microphone: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "High Frequency Words-1",
        //  introduction: {
        //             title: "Most Used Words",
        //             subTitle: "Practice 1",
        //             audio: "prompt/mic"
        //         },
        introduction: {
          title: "Most Used Words",
          subtitle: "Practice 1",
          audio: "prompt/p1"
        },
        playAfter: { audio: "prompt/awesome" },
        instruction: "repeatables/L5-P1",
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },

      rio1: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Read it Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio",
          subtitle: "Part 1"
        },
        playAfter: [
          { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Read it Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio",
          subtitle: "Part 1"
        }
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["awesome", "p1", "p2", "gp", "mic", "practice", "rio", "rio1", "rio2"]
        }
      ]
    },
    review: {
      // "fromLesson": "self",
    },
    data: "lesson9",
    label: 7,
    part: "a"
  },
  10: {
    stages: {

      exp1: {
        type: "DisplayItems",
        subType: "word",
        table: { data: Tables.l5p1, type: "simple" },
        playBefore: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Guided Practice 1",
        instruction: "repeatables/L5-P1",
        //  introduction: {
        //             title: "Most Used Words",
        //             subTitle: "Practice 1",
        //             audio: "prompt/p1"
        //         },
        // playAfter: [
        //   {
        //     afterDelay: 1000,
        //     audio: "micstghtwordsMobile",
        //     beforeDelay: 500
        //   }
        // ],
      },
      p1: {
        type: "DisplayItems",
        subType: "word",
        table: { data: Tables.l5p1, type: "simple" },
        microphone: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "High Frequency Words-2",
        introduction: {
          title: "Most Used Words",
          subtitle: "Practice 1",
          audio: "prompt/p1"
        },
        playAfter: { 'audio': "prompt/awesome" },
        instruction: "repeatables/L5-P1",
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      rio1: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Read it Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio",
          subtitle: "Part 1"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Read it Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio",
          subtitle: "Part 1"
        }
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["awesome", "p1", "p2", "gp", "practice", "rio", "rio2"]
        }
      ]
    },
    review: {
      // "fromLesson": "self",
    },
    data: "lesson10",
    label: 7,
    part: "b"
  },

  11: {
    stages: {
      exp1: {
        type: "DisplayItems",
        subType: "word",
        table: { data: Tables.l5p2, type: "simple" },
        // microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Guided Practice 1",
        instruction: "repeatables/L5-P1",
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "DisplayItems",
        subType: "word",
        table: { data: Tables.l5p2, type: "simple" },
        silenceBuzz: true,
         microphone: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "High Frequency Words-3",
        introduction: {
          title: "Most Used Words",
          subtitle: "Practice 2",
          audio: "prompt/mic"
        },
        instruction: "repeatables/L5-P1",
        // playAfter: [
        //   {
        //     afterDelay: 1000,
        //     audio: "micstghtwordsMobile",
        //     beforeDelay: 500
        //   }
        // ],
      },
      rio2: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Read it Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio",
          subtitle: "Part 2"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Read it Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio",
          subtitle: "Part 2"
        },
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["awesome", "p1", "p2", "gp", "mic", "practice", "rio", "rio1", "rio2"]
        }
      ]
    },
    review: {
      // "fromLesson": "self",
    },
    data: "lesson11",
    label: 8,
    part: "a"
  },
  12: {
    stages: {
      exp1: {
        type: "DisplayItems",
        subType: "word",
        table: { data: Tables.l5p2, type: "simple" },
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Guided Practice 1",
        instruction: "repeatables/L5-P1",
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "DisplayItems",
        subType: "word",
        table: { data: Tables.l5p2, type: "simple" },
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "High Frequency Words-4",
        introduction: {
          title: "Most Used Words",
          subtitle: "Practice 2",
          audio: "prompt/mic"
        },
        instruction: "repeatables/L5-P1",
        // playAfter: [
        //   {
        //     afterDelay: 1000,
        //     audio: "micstghtwordsMobile",
        //     beforeDelay: 500
        //   }
        // ],
      },
      rio2: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Read it Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio",
          subtitle: "Part 2"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        title: "Read it Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio",
          subtitle: "Part 2"
        },
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["awesome", "p1", "p2", "gp", "mic", "rio", "practice", "rio1", "rio2"]
        }
      ]
    },
    review: {
      // "fromLesson": "self",
    },
    data: "lesson12",
    label: 8,
    part: "b"
  },

  13: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        table: { type: "multi", data: Tables.l13 },
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        instruction: "repeatables/L8-P1",
        title: "Part A: Vowel Blends",
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "InsertText",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        background: {
          type: "chaoss",
          content: [
            ["W1", "W4", "W6", "W2", "W5", "W7", "W3", "W8", "W9"],
            // ["W10", "W11", "W12", "W13", "W14", "W15", "W16", "W17", "W18"],
            // ["W19", "W20", "W21", "W22", "W23", "W24", "W25", "W26", "W27"]
          ]
          // content: Tables.l13.map(item => item.table)
          // "content": ['W14','W13','W1', 'W2', 'W4', 'W3', 'W12','W5', 'W6','W7', 'W9','W8', 'W15', 'W18', 'W27', 'W16', 'W17', 'W24', 'W25', 'W26', 'W20', 'W23', 'W22', 'W11', 'W10', 'W21', 'W19']
        },
        delayBefore: 1000,
        title: "Vowel Blends-1 in Random Order",
        timeOut: 55,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        // "instruction": "repeatables/L8-VC",
        // "playAfter": [
        //   {"afterDelay": 1000, "audio": "selectMobile", "beforeDelay": 500}
        // ],
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectvccMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel Blends-1 in Random Order",
        timeOut: 20,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-v", beforeDelay: 500 }
        // ],
      },
      prep: {
        type: "DisplayItems",
        subType: "wordBlend",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 2500,
        steps: [],
        title: "Tap it Out!",
        introduction: {
          title: "Tap it Out!",
          audio: "prompt/prep1"
        }
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "maid",
            blue: true,
            color: "ai"
          },
          {
            type: "audio",
            content: "prompt/gp-maid",
            afterDelay: 1000
          },
        ],
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        //         "instruction": "prompt/n5",
        delayBefore: 1000,
        title: "Vowel Blends: Practice.",
        timeOut: 20,
        introduction: {
          title: "Vowel Blends: Practice",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vcx", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        instruction: "repeatables/word",
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        //         "instruction": "prompt/n5",
        delayBefore: 1000,
        title: "Vowel Blends.",
        timeOut: 20,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/vcpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vcpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" }
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "select", "mic", "prep1", "rio", "vcpract", 'gp', "gp-maid", "gp-seize", "gp-prey", "pause-a"]
        },
         {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/blend/{{key}}.mp3",
          prefix: "blend/",
          data: [
            "u-select",
            "select",
            "gp-u-blend",
            "gp-blend-maid1",
            "gp-blend-maid2",
            "gp-blend-maid3",
            "gp-blend-maid4",
            "gp-blend-prey1",
            "gp-blend-prey2",
            "gp-blend-prey3",
            "gp-blend-fraud1",
            "gp-blend-fraud2",
            "gp-blend-fraud3",
            "gp-blend-fraud4",
            "wh",
            "ea",
            "t",
            "eat",
            "cr",
            "aw",
            "l",
            "awl",
          ]
        }
      ]
    },
    review: {},
    data: "lesson13",
    label: 9,
    part: "a"
  },
  14: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        table: { type: "multi", data: Tables.l14 },
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },

        delayBefore: 1000,
        // "instruction": "repeatables/L8-P1",
        title: "Part B: Vowel Blends",
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "InsertText",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        instruction: "repeatables/select",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        background: {
          type: "chaoss",
          content: [
            // ["W1", "W4", "W6", "W2", "W5", "W7", "W3", "W8", "W9"],
            ["W10", "W11", "W12", "W13", "W14", "W15", "W16", "W17", "W18"],
            // ["W19", "W20", "W21", "W22", "W23", "W24", "W25", "W26", "W27"]
          ]
          // "content": Tables.l8.map(item => item.table)
          // "content": ['W14','W13','W1', 'W2', 'W4', 'W3', 'W12','W5', 'W6','W7', 'W9','W8', 'W15', 'W18', 'W27', 'W16', 'W17', 'W24', 'W25', 'W26', 'W20', 'W23', 'W22', 'W11', 'W10', 'W21', 'W19']
        },
        delayBefore: 1000,
        title: "Vowel Blends-2 in Random Order",
        timeOut: 55,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        // "instruction": "repeatables/L8-VC",
        // "playAfter": [
        //   {"afterDelay": 1000, "audio": "selectMobile", "beforeDelay": 500}
        // ],
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectvccMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel Blends-2 in Random Order",
        timeOut: 20,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-v", beforeDelay: 500 }
        // ],
      },
      prep: {
        type: "DisplayItems",
        subType: "wordBlend",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 2500,
        steps: [],
        title: "Tap it Out!",
        introduction: {
          title: "Tap it Out!",
          audio: "prompt/prep1"
        }
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        instruction: "repeatables/word",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        //         "instruction": "prompt/n5",
        delayBefore: 1000,
        title: "Vowel Blends: Practice.",
        steps: [
          {
            type: "display",
            content: "dew",
            blue: true,
            color: "ew"
          },
          {
            type: "audio",
            content: "prompt/gp-dew",
            afterDelay: 1000
          },
        ],
        timeOut: 20,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vc", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/word",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        //         "instruction": "prompt/n5",
        delayBefore: 1000,
        title: "Vowel Blends.",
        timeOut: 20,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/vcpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vcpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        title: "Read It Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        title: "Read It Out",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        introduction: { title: "Read it Out!", audio: "prompt/rio" }
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "select", "mic", "prep1", "rio", "vcpract", 'gp', "gp-dew", "gp-broil", "gp-droop", "mouse-a"]
        },
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/audios/lesson/{{lessonId}}/blend/{{key}}.mp3",
          prefix: "blend/",
          data: [
            "u-select",
            "select",
            "gp-u-blend",
            "gp-blend-dew1",
            "gp-blend-dew2",
            "gp-blend-dew3",
            "gp-blend-broil1",
            "gp-blend-broil2",
            "gp-blend-broil3",
            "gp-blend-broil4",
            "gp-blend-droop1",
            "gp-blend-droop2",
            "gp-blend-droop3",
            "gp-blend-droop4",
            "ou",
            "ch",
            "ouch",
            "pl",
            "oy",
          ]
        }
      ]
    },
    review: {},
    data: "lesson14",
    label: 9,
    part: "b"
  },

  
  
  15: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        table: { "type": "multi", "data": Tables.l15 },
        
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        instruction: "repeatables/L8-P1",
        title: "Part C: Vowel Blends",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectMobile", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "InsertText",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        instruction: "repeatables/select",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        background: {
          type: "chaoss",
          content: [
            // ["W1", "W4", "W6", "W2", "W5", "W7", "W3", "W8", "W9"],
            // ["W10", "W11", "W12", "W13", "W14", "W15", "W16", "W17", "W18"],
            ["W19", "W20", "W21", "W22", "W23", "W24", "W25", "W26", "W27"]
          ]
          // "content": Tables.l8.map(item => item.table)
          // "content": ['W14','W13','W1', 'W2', 'W4', 'W3', 'W12','W5', 'W6','W7', 'W9','W8', 'W15', 'W18', 'W27', 'W16', 'W17', 'W24', 'W25', 'W26', 'W20', 'W23', 'W22', 'W11', 'W10', 'W21', 'W19']
        },
        delayBefore: 1000,
        title: "Vowel Blends-3 in Random Order",
        timeOut: 55,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        instruction: "repeatables/select",
        // "playAfter": [
        //   {"afterDelay": 1000, "audio": "selectMobile", "beforeDelay": 500}
        // ],
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectvccMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel Blends-3 in Random Order",
        timeOut: 20,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-v", beforeDelay: 500 }
        // ],
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        instruction: "repeatables/word",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel Blends: Practice.",
        timeOut: 20,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vc", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "test",
            blue: true,
            color: "es"
          },
          {
            type: "audio",
            content: "prompt/gp-test",
            afterDelay: 1000
          },
        ],
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel Blends.",
        timeOut: 20,
        introduction: {
          title: "Vowel Blends",
          subtitle: "(Random Order)",
          audio: "prompt/vcpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vcpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" }
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "select", "mic", "rio", "vcpract", 'gp', "gp-test", "gp-soap", "gp-spent", "stir-a"]
        }
      ]
    },
    review: {},
    data: "lesson15",
    label: 10
  },

  16: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        table: { type: "multi", data: Tables.l16 },
        playBefore: true,
        silenceBuzz: true,
        guided: true,

        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        // "instruction": "repeatables/L8-P1",
        title: "Vowel/Consonant Blends 1",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectvccMobile", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "InsertText",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        background: {
          type: "chaoss",
          content: [
            ["W1", "W10", "W6", "W2", "W5", "W7", "W3", "W11", "W9"],
            // ["W10", "W11", "W12", "W13", "W14", "W15", "W16", "W17", "W18"],
            // ["W19", "W20", "W21", "W22", "W23", "W24", "W25", "W26", "W27"]
          ]
          // "content": Tables.l8.map(item => item.table)
          // "content": ['W14','W13','W1', 'W2', 'W4', 'W3', 'W12','W5', 'W6','W7', 'W9','W8', 'W15', 'W18', 'W27', 'W16', 'W17', 'W24', 'W25', 'W26', 'W20', 'W23', 'W22', 'W11', 'W10', 'W21', 'W19']
        },
        delayBefore: 1000,
        title: "Vowel/Consonant Blends-1 in Random Order",
        timeOut: 55,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        instruction: "repeatables/select",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectvccMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel/Consonant Blends-1 in Random Order",
        timeOut: 20,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-vcc", beforeDelay: 500 }
        // ],
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "sect",
            blue: true,
            color: "ect"
          },
          {
            type: "audio",
            content: "prompt/gp-sect",
            afterDelay: 1000
          },
        ],
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        //         "instruction": "prompt/n5",
        delayBefore: 1000,
        title: "Vowel / Consonant Blends: Practice.",
        timeOut: 20,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vcc", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/word",

        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel/Consonant Blends.",
        timeOut: 20,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/vccpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vccpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" }
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "select", "mic", "gp", "vccpract", "rio", "gp-sect", "gp-tact", "gp-rail", "hound-a"]
        }
      ]
    },
    review: {},
    data: "lesson16",
    label: 11,
    part: "a"
  },
  17: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        table: { type: "multi", data: Tables.l17 },
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        instruction: "repeatables/L8-P1",
        title: "Vowel/Consonant Blends 2",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectvccMobile", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "InsertText",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        background: {
          type: "chaoss",
          content: [
            // ["W1", "W4", "W6", "W2", "W5", "W7", "W3", "W8", "W9"],
            // ["W10", "W11", "W12", "W13", "W14", "W15", "W16", "W17", "W18"],
            ["W4", "W8", "W21", "W22", "W12", "W24", "W25", "W26", "W27", "W28"]
          ]
          // "content": Tables.l8.map(item => item.table)
          // "content": ['W14','W13','W1', 'W2', 'W4', 'W3', 'W12','W5', 'W6','W7', 'W9','W8', 'W15', 'W18', 'W27', 'W16', 'W17', 'W24', 'W25', 'W26', 'W20', 'W23', 'W22', 'W11', 'W10', 'W21', 'W19']
        },
        delayBefore: 1000,
        title: "Vowel/Consonant Blends 2 in Random Order",
        timeOut: 55,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        instruction: "repeatables/select",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectvccMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel/Consonant Blends-2 in Random Order",
        timeOut: 20,
        introduction: {
          title: "Vowel/Consonant Blends-2",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-vcc", beforeDelay: 500 }
        // ],
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "stuck",
            blue: true,
            color: "uck"
          },
          {
            type: "audio",
            content: "prompt/gp-stuck",
            afterDelay: 1000
          },
        ],
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel/Consonant Blends: Practice",
        timeOut: 20,
        introduction: {
          title: "Vowel / Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vcc", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/word",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel/Consonant Blends",
        timeOut: 20,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/vccpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vccpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 45,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "mic", "select", "gp", "vccpract", "rio", "gp-stuck", "gp-shrimp", "gp-chuck", "tale-a"]
        }
      ]
    },
    review: {},
    data: "lesson17",
    label: 11,
    part: "b"
  },

  18: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        table: { type: "multi", data: Tables.l18 },
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        delayBefore: 1000,
        instruction: "repeatables/L8-P1",
        title: "Vowel/Consonant Blends 3",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectvccMobile", beforeDelay: 500 }
        // ],
      },
      p2: {
        type: "InsertText",
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        background: {
          type: "chaoss",
          content: [
            // ["W1", "W4", "W6", "W2", "W5", "W7", "W3", "W8", "W9"],
            ["W19", "W20", "W13", "W14", "W15", "W16", "W17", "W18"],
            // ["W19", "W20", "W21", "W22", "W23", "W24", "W25", "W26", "W27"]
          ]
          // "content": Tables.l8.map(item => item.table)
          // "content": ['W14','W13','W1', 'W2', 'W4', 'W3', 'W12','W5', 'W6','W7', 'W9','W8', 'W15', 'W18', 'W27', 'W16', 'W17', 'W24', 'W25', 'W26', 'W20', 'W23', 'W22', 'W11', 'W10', 'W21', 'W19']
        },
        delayBefore: 1000,
        title: "Vowel/Consonant Blends-3 in Random Order",
        timeOut: 55,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/select"
        },
        instruction: "repeatables/select",
        // playAfter: [
        //   { afterDelay: 1000, audio: "selectvccMobile", beforeDelay: 500 }
        // ],
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel/Consonant Blends-3 in Random Order",
        timeOut: 20,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/mic"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "micMobile/mic-vcc", beforeDelay: 500 }
        // ],
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "soft",
            blue: true,
            color: "oft"
          },
          {
            type: "audio",
            content: "prompt/gp-soft",
            afterDelay: 1000
          },
        ],
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Blending with Vowel / Consonant Blends.",
        timeOut: 20,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vcc", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/word",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Vowel / Consonant Blends",
        timeOut: 20,
        introduction: {
          title: "Vowel/Consonant Blends",
          subtitle: "(Random Order)",
          audio: "prompt/vccpract"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vccpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 60,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      extra: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
      },
    },
    audioSets: {
      _: [
        {
          audio:
            "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
          prefix: "prompt/",
          data: ["n1", "n2", "n3", "n4", "n5", "rio", "select", "gp", "mic", "vccpract", "gp-soft", "gp-look", "gp-meal", "steel-a"]
        }
      ]
    },
    review: {},
    data: "lesson18",
    label: 11,
    part: "c"
  },

  19: {
    stages: {
      prep: {
        type: "DisplayItems",
        subType: "phonetics",
        silenceBuzz: true,
        delayBefore: 2500,
        steps: [
          {
            type: "stepLister",
            content: `<b>Identify the vowels/vowel combinations. Place a dot under the vowels.</b>`,
            step: 1
          },
          {
            type: "audio",
            content: "prompt/exp-1-1",
            afterDelay: 1000
          },
          {
            type: "stepLister",
            content: `<b>Look between the <u>first</u> two vowels or Vowel combinations.</b>
                            <ul>
                                <li>Identify the <b>2 consonant</b> sounds are Side-by-Side, draw syllable line or
                                    separate them. <img src='https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/12/perform.png'/></li>
                            </ul>
                            <center><b>-</b> or <b>-</b></center>
                            <ul>
                                <li>If there's only <b>one consonant</b> sound, draw a syllable line after the first
                                    vowel. <img src='https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/12/human.png'/></li>
                            </ul>
                        `,
            step: 2
          },
          {
            type: "audio",
            content: "prompt/exp-1-2",
            afterDelay: 1000
          },
          {
            type: "stepLister",
            content:
              `<span >3 or more active vowels:  <img
                                src='https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/12/complement.png'/></span>
                            <ul>
                                <li>Repeat step 3 <u>between each vowel or vowel combination.</u></li>
                            </ul>`
            ,
            clearPrevious: true,
            step: 3
          },
          {
            type: "audio",
            content: "prompt/exp-1-3",
            afterDelay: 3000
          },
          {
            type: "video",
            content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/12/demonstration.mp4"
          },
          {
            type: "images",
            content: ["https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/12/color_perform.png", "https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/12/color_human.png"],
          },
          {
            type: "audio",
            content: "prompt/exp-2",
            afterDelay: 2000
          },
        ],
        playAfter: {
          afterDelay: 3000,
          audio: "prompt/exp-7"
        },
        lastStep: {
          type: "images",
          content: ["https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/12/protest.png", "https://d3vx0tne0vxeo1.cloudfront.net/assets/images/lesson/12/mamal.png"]
        },
        title: "Vowel/Consonant Blends",
        introduction: {
          title: "Vowel/Consonant Blends",
          subTitle: "Guided Practice",
          audio: "prompt/exp-1"
        }
      },
      p1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        silenceBuzz: true,
        timeOut: 15,
        instruction: "repeatables/L12-P1",
        delayBefore: 1000,
        title: "Practice 1",
        studyButton: {
          title: "Replay video",
          type: "video",
          content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/12/demonstration.mp4"
        },
        introduction: {
          title: "Decoding Multisyllabic Words",
          subTitle: "Practice 1",
          audio: "prompt/p1-1"
        },
        steps: [
          {
            type: "audio",
            content: "prompt/p1-2"
          }
        ],
        uiBeforeSteps: true
      },
      p2: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        silenceBuzz: true,
        timeOut: 25,
        studyButton: {
          title: "Replay video",
          type: "video",
          content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/12/demonstration.mp4"
        },
        instruction: "repeatables/L12-P2",
        delayBefore: 1000,
        title: "Practice 2",
        introduction: {
          title: "Decoding Multisyllabic Words",
          subTitle: "Practice 2",
          audio: "prompt/p2-1"
        },
        steps: [
          {
            type: "audio",
            content: "prompt/p2-2"
          }
        ],
        uiBeforeSteps: true
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 40,
        instruction: "repeatables/L20",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio"
        }

      }
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["exp-1", "exp-1-1", "exp-1-2", "exp-1-3", "exp-2", "exp-3", "exp-4", "exp-5", "exp-5-1", "exp-5-2", "exp-6", "exp-7", "exp-8", "p1-1", "p1-2", "p2-1", "p2-2", "rio"]
      }]
    },
    review: {
      fromLesson: "self",
      stages: ["prep"]
    },
    data: "lesson19",
    label: 12
  },
  20: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        instruction: "repeatables/L17-P1",
        delayBefore: 1000,
        title: "Practice 1",
        table: {
          type: "multi",
          data: Tables.l24,
          isSmall: true
        },
        introduction: {
          title: "Silent E & Irregular Words",
          subTitle: "Practice 1"
        }
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        // table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/exp1",
        delayBefore: 1000,
        title: "Silent E & Irregular Words",
        timeOut: 20,
        introduction: {
          title: "Silent E & Irregular Words",
          // subTitle: "(List 6)",
          audio: "prompt/exp1"
        }
      },
      prep1: {
        type: "DisplayItems",
        subType: "phonetics",
        silenceBuzz: true,
        steps: [
          {
            type: "video",
            content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/17/video-1.mp4"
          },
        ],
        delayBefore: 2500,
        title: "Silent E (Guided Practice)",
        introduction: {
          title: "Silent E & Irregular Words",
          subTitle: "Silent E (Guided Practice)",
          audio: "prompt/d1"
        }
      },
      prep2: {
        type: "DisplayItems",
        subType: "phonetics",
        silenceBuzz: true,
        steps: [
          {
            type: "video",
            content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/17/video-2.mp4"
          },
        ],
        title: "Silent E (Guided Practice)"
      },

      p2: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        silenceBuzz: true,
        instruction: "repeatables/L17-P2",
        delayBefore: 1000,
        title: "Blending with Silent E",
        introduction: {
          title: "Silent E & Irregular Words",
          subTitle: "Blending with Silent E",
          audio: "prompt/d2"
        }
      },
      rio: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 45,
        instruction: "repeatables/L20",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio"
        }

      },
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/24/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["d1", "d2", "e1", "e2", "e3", "rio", "exp1"]
      }]
    },
    review: {
      fromLesson: "self",
      stages: ["prep1", "prep2"]
    },
    // Content rotated in from old L24 — its CDN audio still lives in flaudio/24.
    audioLessonId: 24,
    data: "lesson20",
    label: 17
  },
  21: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        delayBefore: 1000,
        microphone: false,
        timeOut: -1,
        title: "Practice 1",
        instruction: "repeatables/L13-P1",
        table: {
          data: Tables.l20,
          type: "complex"
        },
      },

      p2: {
        type: "InsertText",
        background: {
          type: "chaos",
          content: shuffleArray(Array.from(new Array(13)).map((_, i) => `W${i + 1}`).filter(item => item != 'W7'))
        },
        playBefore: true,
        silenceBuzz: true,
        inputPrefix: "Prefix",
        instruction: "repeatables/select",
        delayBefore: 1000,
        title: "Practice 2",
        timeOut: 35,
        introduction: {
          title: "Most Common Prefixes-1",
          subTitle: "(Random Order)",
          audio: "prompt/select"
        }
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        // table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n4",
        delayBefore: 1000,
        title: "Most Common Prefixes-1",
        timeOut: 20,
        introduction: {
          title: "Most Common Prefixes-1",
          subTitle: "(Random Order)",
          audio: "prompt/mic"
        }
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        instruction: "repeatables/word",
        steps: [
          {
            type: "stepLister",
            content: `<b>How to Decode a Prefix.</b>`,
            step: 1
          },
          {
            type: "video",
            content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/20/prefix-1.mp4"
          },
          {
            type: "display",
            content: "antilock",
            blue: true,
            color: "anti"
          },
          {
            type: "audio",
            content: "prompt/gp-anti",
            afterDelay: 1000
          },
        ],
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Most Common Prefixes: practice",
        timeOut: 20,
        introduction: {
          title: "Most Common Prefixes-1",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vcc", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/word2",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Most Common Prefixes-1",
        timeOut: 20,
        introduction: {
          title: "Most Common Prefixes-1",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vccpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/20/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["e1", "n3", "n4", "select", "mic", "gp", "rio", "gp-anti", "gp-dis", "gp-en"]
      }]
    },
    review: {
      // fromLesson: "self",
    },
    // Content rotated in from old L20 — its CDN audio still lives in flaudio/20.
    audioLessonId: 20,
    data: "lesson21",
    label: 13
  },

  22: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        delayBefore: 1000,
        microphone: false,
        timeOut: -1,
        title: "Practice 1",
        instruction: "repeatables/L13-P1",
        table: {
          data: Tables.l21,
          type: "complex"
        },
      },

      p2: {
        type: "InsertText",
        background: {
          type: "chaos",
          content: shuffleArray(Array.from(new Array(10)).map((_, i) => `W${i + 14}`).concat(["W7"]))
        },
        playBefore: true,
        silenceBuzz: true,
        inputPrefix: "Prefix",
        instruction: "repeatables/select",
        delayBefore: 1000,
        title: "Practice 2",
        timeOut: 35,
        introduction: {
          title: "Most Common Prefixes-2",
          subTitle: "(Random Order)",
          audio: "prompt/select"
        }
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        // table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/n4",
        delayBefore: 1000,
        title: "Most Common Prefixes-2",
        timeOut: 20,
        introduction: {
          title: "Most Common Prefixes-2",
          subTitle: "(Random Order)",
          audio: "prompt/mic"
        }
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "semicircle",
            blue: true,
            color: "semi"
          },
          {
            type: "audio",
            content: "prompt/gp-semi",
            afterDelay: 1000
          },
        ],
        // instruction: "prompt/n5",
        delayBefore: 1000,
        title: "Most Common Prefixes: Practice",
        timeOut: 20,
        introduction: {
          title: "Most Common Prefixes-2",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vcc", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        instruction: "repeatables/word2",
        delayBefore: 1000,
        title: "Most Common Prefixes 2",
        timeOut: 20,
        introduction: {
          title: "Most Common Prefixes 2",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vccpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/21/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["e1", "n3", "n4", "select", "mic", "gp", "rio", "gp-sub", "gp-semi"]
      }]
    },
    review: {
      // fromLesson: "self",
    },
    // stages: {
    //   prep: {
    //     type: "DisplayItems",
    //     subType: "word",
    //     silenceBuzz: true,
    //     delayBefore: 2500,
    //     microphone: true,
    //     timeOut: 15,
    //     steps: [
    //       {
    //         type: "display",
    //         content: "pre-heat"
    //       },
    //       {
    //         type: "audio",
    //         content: "prompt/e2"
    //       }
    //     ],
    //     title: "Blending with Prefixes",
    //     introduction: {
    //       title: "Blending with Prefixes",
    //       subTitle: "Guided Practice",
    //       audio: "prompt/e1"
    //     }
    //   },
    //   p1: {
    //     type: "DisplayItems",
    //     subType: "word",
    //     microphone: true,
    //     silenceBuzz: true,
    //     timeOut: 15,
    //     instruction: "repeatables/L14-P1",
    //     delayBefore: 1000,
    //     title: "Practice 1",
    //     introduction: {
    //       title: "Blending with Prefixes",
    //       subTitle: "Practice 1",
    //       audio: "prompt/p1-1"
    //     },
    //     steps: [
    //       {
    //         type: "audio",
    //         content: "prompt/p1-2"
    //       }
    //     ],
    //     uiBeforeSteps: true
    //   },
    //   p2: {
    //     type: "DisplayItems",
    //     subType: "word",
    //     microphone: true,
    //     silenceBuzz: true,
    //     instruction: "repeatables/L14-P2",
    //     delayBefore: 1000,
    //     title: "Practice 2",
    //     introduction: {
    //       title: "Blending with Prefixes",
    //       subTitle: "Practice 2",
    //       audio: "prompt/p2-1"
    //     },
    //     steps: [
    //       {
    //         type: "audio",
    //         content: "prompt/p2-2"
    //       }
    //     ],
    //     uiBeforeSteps: true
    //   },
    //   p3: {
    //     type: "InsertText",
    //     silenceBuzz: true,
    //     instruction: "repeatables/L14-P3",
    //     delayBefore: 1000,
    //     timeOut: 45,
    //     title: "Practice 3",
    //     inputPrefix: "Blend",
    //     introduction: {
    //       title: "Blending with Prefixes",
    //       subTitle: "Practice 3",
    //       audio: "prompt/p3-1"
    //     },
    //     background: {
    //       type: "options",
    //       content: [
    //         [["pre", "re"], ["un", "mid"], ["mis", "de"]],
    //         [["part", "run"], ["start", "lead"], ["do", "way"], ["ploy", "real"]]
    //       ],
    //       focalIndex: 1
    //     },
    //     steps: [
    //       {
    //         type: "audio",
    //         content: "prompt/p3-2"
    //       }
    //     ],
    //     uiBeforeSteps: true
    //   },
    //   rio: {
    //     type: "ReadItOut",
    //     subType: "sequential",
    //     microphone: true,
    //     silenceBuzz: true,
    //     delayBefore: 1000,
    //     timeOut: 45,
    //     microPhoneConfig: {
    //       waitTime: 35000,
    //       timeOut: 7000,
    //       wrLength: 50
    //     },
    //     introduction: {
    //       title: "Read it Out!",
    //       audio: "prompt/rio"
    //     }

    //   },
    // },
    // audioSets: {
    //   _: [{
    //     audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/21/lesson/chars/{{key}}.mp3",
    //     prefix: "char/",
    //     data: ["un", "hurt", "mid", "land"]
    //   },
    //   {
    //     audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/21/lesson/prompts/{{key}}.mp3",
    //     prefix: "prompt/",
    //     data: ["e1", "e2", "e3", "e4", "n1-1", "n1-2", "n1", "p1-1", "p1-2", "p2-1", "p2-2", "p3-1", "p3-2", "rio"]
    //   }
    //   ]
    // },
    // review: {
    //   // fromLesson: 13,
    //   // stages: ["p1"]
    // },
    // Content rotated in from old L21 — its CDN audio still lives in flaudio/21.
    audioLessonId: 21,
    data: "lesson22",
    label: 14
  },
  23: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        delayBefore: 1000,
        title: "Practice 1",
        instruction: "repeatables/L15-P1",
        table: {
          data: Tables.l22,
          type: "complex"
        },
      },
      p2: {
        type: "InsertText",
        background: {
          type: "chaos",
          content: shuffleArray(Array.from(new Array(15)).map((_, i) => `W${i + 1}`))
        },
        playBefore: true,
        silenceBuzz: true,
        instruction: "repeatables/select",
        delayBefore: 1000,
        title: "Practice 2",
        inputPrefix: "Most Common Suffix-1",
        timeOut: 35,
        introduction: {
          title: "Most Common Suffix-1",
          subTitle: "Practice 2",
          audio: "prompt/select"
        }
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        // table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/e2",
        delayBefore: 1000,
        title: "Most Common Suffix-1",
        timeOut: 20,
        introduction: {
          title: "Most Common Suffix-1",
          subTitle: "(Random Order)",
          audio: "prompt/mic"
        }
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        instruction: "repeatables/word",
        steps: [
          {
            type: "stepLister",
            content: `<b>How to Decode a Suffix.</b>`,
            step: 1
          },
          {
            type: "video",
            content: "https://d3vx0tne0vxeo1.cloudfront.net/videos/lesson/22/suffix-1.mp4"
          },
          {
            type: "display",
            content: "enjoyable",
            blue: true,
            color: "able"
          },
          {
            type: "audio",
            content: "prompt/gp-able",
            afterDelay: 1000
          },
        ],
        delayBefore: 1000,
        title: "Most Common Suffix: Practice",
        timeOut: 20,
        introduction: {
          title: "Most Common Suffix-1",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vcc", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        instruction: "repeatables/word",
        delayBefore: 1000,
        title: "Most Common Suffix-1",
        timeOut: 20,
        introduction: {
          title: "Most Common Suffix-1",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vccpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },

    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/22/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["e1", "e2", "p2-1", "p2-2", "select", "mic", "gp", "rio", "gp-able", "gp-ion", "gp-ful"]
      }]
    },
    review: {
      // fromLesson: "self",
    },
    // Content rotated in from old L22 — its CDN audio still lives in flaudio/22.
    audioLessonId: 22,
    data: "lesson23",
    label: 15
  },
  24: {
    stages: {
      p1: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        delayBefore: 1000,
        title: "Practice 1",
        instruction: "repeatables/L15-P1",
        table: {
          data: Tables.l23,
          type: "complex"
        },
      },
      p2: {
        type: "InsertText",
        background: {
          type: "chaos",
          content: shuffleArray(
            Array.from({ length: 15 }, (_, i) => `W${i + 16}`).filter((k) => k !== "W26")
          )
        },
        playBefore: true,
        silenceBuzz: true,
        instruction: "repeatables/select",
        delayBefore: 1000,
        title: "Practice 2",
        inputPrefix: "Most Common Suffix-2",
        timeOut: 35,
        introduction: {
          title: "Most Common Suffix-2",
          subTitle: "Practice 2",
          audio: "prompt/select"
        }
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
         microphone: true,
        playBefore: false,
        silenceBuzz: true,
        // table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/e2",
        delayBefore: 1000,
        title: "Most Common Suffix-2",
        timeOut: 20,
        introduction: {
          title: "Most Common Suffix-2",
          subTitle: "(Random Order)",
          audio: "prompt/mic"
        }
      },
      exp1: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: true,
        silenceBuzz: true,
        guided: true,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        instruction: "repeatables/word",
        steps: [
          {
            type: "display",
            content: "conservative",
            blue: true,
            color: "ative"
          },
          {
            type: "audio",
            content: "prompt/gp-ative",
            afterDelay: 1000
          },
        ],
        delayBefore: 1000,
        title: "Most Common Suffix: Practice",
        timeOut: 20,
        introduction: {
          title: "Most Common Suffix-2",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "gpMobile/gp-vcc", beforeDelay: 500 }
        // ],
      },
      p3: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        playBefore: false,
        silenceBuzz: true,
        guided: false,
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        // "table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        // instruction: "prompt/n5",
        instruction: "repeatables/word",
        delayBefore: 1000,
        title: "Most Common Suffix-2",
        timeOut: 20,
        introduction: {
          title: "Most Common Suffix-2",
          subtitle: "(Random Order)",
          audio: "prompt/gp"
        },
        // playAfter: [
        //   { afterDelay: 1000, audio: "vccpractMobile", beforeDelay: 500 }
        // ],
      },
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        guided: false,
        instruction: "repeatables/L20",
        correctPrompt: {
          base: "correct",
          flow: "random",
          from: [1, 2, 3, 4, 5, 6, 7]
        },
        timeOut: 30,
        delayBefore: 1000,
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: { title: "Read it Out!", audio: "prompt/rio" },
        // playAfter: [
        //   { afterDelay: 1000, audio: "roiMobile", beforeDelay: 500 }
        // ],
      },
      
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/23/lesson/chars/{{key}}.mp3",
        prefix: "char/",
        data: ["spec", "ial", "enjoy", "ment"]
      },
      {
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/23/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["e1", "e2", "e3", "e4", "p1-1", "p1-2", "p2-1", "p2-2", "p3-1", "p3-2", "rio", "select", "mic", "gp", "gp-ative", "gp-ness"]
      }
      ]
    },
    review: {
      fromLesson: 15,
      stages: ["p1"]
    },
    // Content rotated in from old L23 — its CDN audio still lives in flaudio/23.
    audioLessonId: 23,
    data: "lesson24",
    label: 16
  },
  25: {
    stages: {
      exp1: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,
        table: {
          type: "multi",
          data: Tables.l25
        },
        instruction: "prompt/e2",
        delayBefore: 1000,
        title: "Review of Commonly Mispronounced Sounds",
        timeOut: 20,
        introduction: {
          title: "Review of Commonly Mispronounced Sounds",
          // subTitle: "(List 6)",
          audio: "prompt/gp1"
        }
      },
      exp2: {
        type: "DisplayItems",
        subType: "word",
        playBefore: false,
        silenceBuzz: true,
        microphone: true,
        table: {
          type: "multi",
          data: Tables.l18Repeat
        },
        // table: {
        //     type: "multi",
        //     data: Tables.l6
        // },
        instruction: "prompt/exp1",
        delayBefore: 1000,
        title: "Review of Commonly Mispronounced Sounds",
        timeOut: 20,
        introduction: {
          title: "Review of Commonly Mispronounced Sounds",
          // subTitle: "(List 6)",
          audio: "prompt/gp2"
        }
      },
      p1: {
        type: "DisplayItems",
        subType: "word",
        playBefore: true,
        silenceBuzz: true,

        timeOut: 15,
        instruction: "repeatables/L18-GP",
        delayBefore: 1000,
        title: "Guided Practice",
        introduction: {
          title: "Commonly Mispronounced Sounds",
          subTitle: "Guided Practice",
          audio: "prompt/gp3"

        }
      },
      p2: {
        type: "DisplayItems",
        subType: "word",
        microphone: true,
        silenceBuzz: true,
        instruction: "repeatables/L18-P1",
        delayBefore: 1000,
        timeOut: 30,
        title: "Review of Commonly Mispronounced Sounds",
        introduction: {
          title: "Review of Commonly Mispronounced Sounds",
          audio: "prompt/p1-1"
        },
        steps: [
          {
            type: "audio",
            content: "prompt/p1-2",
            afterDelay: 500
          }
        ],
        uiBeforeSteps: true
      },
      rio: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 40,
        instruction: "repeatables/L20",
        microPhoneConfig: {
          waitTime: 50000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Read it Out!",
        introduction: {
          title: "Read it Out!",
          audio: "prompt/rio"
        }

      },
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["exp1", "e1", "e2", "p1-1", "p1-2", "rio", "bp", "gp1", "gp2", "gp3"]
      }]
    },
    review: {
      fromLesson: "self",
      stages: ["p2"]
    },
    data: "lesson25",
    label: 18
  },

  26: {
    stages: {
      rio: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 20,
        instruction: "repeatables/L20",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Sentence Practice",
        instruction: "repeatables/L19",
        introduction: {
          title: "Common Phrases & Sentence Practice",
          audio: "prompt/instructions"
        }

      },
      rio1: {
        type: "ReadItOut",
        subType: "sequential",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 30,
        instruction: "repeatables/L20",
        microPhoneConfig: {
          waitTime: 35000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Sentence Practice",
        instruction: "repeatables/L19",
        introduction: {
          title: "Common Phrases & Sentence Practice",
          audio: "prompt/instructions2"
        }

      },
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["e1", "instructions","instructions2"]
      }]
    },
    review: {
      // Full-word lessons (26/27) review the Guided Practice from L19.
      fromLesson: 19,
      stages: ["prep"]
    },
    data: "lesson26",
    label: 19
  },

  27: {
    stages: {
      rio: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        instruction: "repeatables/L20",
        timeOut: 2 * 60,
         microPhoneConfig: {
          waitTime: ((2 * 60) + 20) * 1000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Short Stories",
        // introduction: {
        //   title: "Short Stories",
        //   audio: "prompt/instructions"
        // }

      },
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["e1", "instructions"]
      }]
    },
    review: {
      // Full-word lessons (26/27) review the Guided Practice from L19.
      fromLesson: 19,
      stages: ["prep"]
    },
    data: "lesson27",
    label: 20
  },

  28: {
    stages: {
      l3: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 2 * 60,
        microPhoneConfig: {
          waitTime: ((2 * 60) + 20) * 1000,
          timeOut: 7000,
          wrLength: 50
        },
        title: "Level 3",
        instruction: "repeatables/L21",
        steps: [
          {
            type: "preview",
            timeOut: 3 * 60,
            disabled: true
          },
          {
            type: "audio",
            content: "prompt/l3-2"
          },
          {
            type: "preview",
            timeOut: 3 * 60
          },
          {
            type: "audio",
            content: "prompt/l3f-1",
            uiBefore: true
          },
          {
            type: "audio",
            content: "prompt/l3f-2",
            uiBefore: true
          },
        ],
        introduction: {
          title: "Fluency Read",
          subTitle: "Level 3",
          audio: "prompt/l3-1"
        }

      },
      l4: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        timeOut: 2 * 60,
        microPhoneConfig: {
          waitTime: ((2 * 60) + 20) * 1000,
          timeOut: 7000,
          wrLength: 50
        },
        instruction: "repeatables/L21",
        title: "Level 4",
        steps: [

          {
            type: "preview",
            timeOut: 3 * 60,
            disabled: true
          },
          {
            type: "audio",
            content: "prompt/l4-2"
          },
          {
            type: "preview",
            timeOut: 3 * 60
          },
          {
            type: "audio",
            content: "prompt/l4f-1",
            uiBefore: true
          },
          {
            type: "audio",
            content: "prompt/l4f-2",
            uiBefore: true
          },
        ],
        introduction: {
          title: "Fluency Read",
          subTitle: "Level 4",
          audio: "prompt/l4-1"
        }

      },
      l5: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 2.5 * 60,
        microPhoneConfig: {
          waitTime: ((2.5 * 60) + 20) * 1000,
          timeOut: 7000,
          wrLength: 50
        },
        instruction: "repeatables/L21",
        title: "Level 5",
        steps: [

          {
            type: "preview",
            timeOut: 3 * 60,
            disabled: true
          },
          {
            type: "audio",
            content: "prompt/l5-2"
          },
          {
            type: "preview",
            timeOut: 3 * 60
          },
          {
            type: "audio",
            content: "prompt/l5f-1",
            uiBefore: true
          },
          {
            type: "audio",
            content: "prompt/l5f-2",
            uiBefore: true
          },
        ],
        introduction: {
          title: "Fluency Read",
          subTitle: "Level 5",
          audio: "prompt/l5-1"
        }
      },
      l6: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 3.5 * 60,
        microPhoneConfig: {
          waitTime: ((3.5 * 60) + 20) * 1000,
          timeOut: 7000,
          wrLength: 50
        },
        instruction: "repeatables/L21",
        title: "Level 6",
        steps: [

          {
            type: "preview",
            timeOut: 3 * 60,
            disabled: true
          },
          {
            type: "audio",
            content: "prompt/l6-2"
          },
          {
            type: "preview",
            timeOut: 3 * 60
          },
          {
            type: "audio",
            content: "prompt/l6f-1",
            uiBefore: true
          },
          {
            type: "audio",
            content: "prompt/l6f-2",
            uiBefore: true
          },
        ],
        introduction: {
          title: "Fluency Read",
          subTitle: "Level 6",
          audio: "prompt/l6-1"
        }

      },
      l7: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 5 * 60,
        microPhoneConfig: {
          waitTime: ((4.5 * 60) + 20) * 1000,
          timeOut: 7000,
          wrLength: 50
        },
        instruction: "repeatables/L21",
        title: "Level 7",
        steps: [

          {
            type: "preview",
            timeOut: 5 * 60,
            disabled: true
          },
          {
            type: "audio",
            content: "prompt/l6-2"
          },
          {
            type: "preview",
            timeOut: 5 * 60
          },
          {
            type: "audio",
            content: "prompt/l7f-1",
            uiBefore: true
          },
          {
            type: "audio",
            content: "prompt/l6f-2",
            uiBefore: true
          },
        ],
        introduction: {
          title: "Fluency Read",
          subTitle: "Level 7",
          audio: "prompt/l7f-1"
        }
      },
      l8: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 5 * 60,
        microPhoneConfig: {
          waitTime: ((4.5 * 60) + 20) * 1000,
          timeOut: 7000,
          wrLength: 50
        },
        instruction: "repeatables/L21",
        title: "Level 8",
        steps: [

          {
            type: "preview",
            timeOut: 5 * 60,
            disabled: true
          },
          {
            type: "audio",
            content: "prompt/l6-2"
          },
          {
            type: "preview",
            timeOut: 5 * 60
          },
          {
            type: "audio",
            content: "prompt/l8f-1",
            uiBefore: true
          },
          {
            type: "audio",
            content: "prompt/l6f-2",
            uiBefore: true
          },
        ],
        introduction: {
          title: "Fluency Read",
          subTitle: "Level 8",
          audio: "prompt/l8f-1"
        }
      },
      l9: {
        type: "ReadItOut",
        subType: "large",
        microphone: true,
        silenceBuzz: true,
        delayBefore: 1000,
        timeOut: 5 * 60,
        microPhoneConfig: {
          waitTime: ((4.5 * 60) + 20) * 1000,
          timeOut: 7000,
          wrLength: 50
        },
        instruction: "repeatables/L21",
        title: "Level 9",
        steps: [
          {
            type: "preview",
            timeOut: 5 * 60,
            disabled: true
          },
          {
            type: "audio",
            content: "prompt/l6-2"
          },
          {
            type: "preview",
            timeOut: 5 * 60
          },
          {
            type: "audio",
            content: "prompt/l9f-1",
            uiBefore: true
          },
          {
            type: "audio",
            content: "prompt/l6f-2",
            uiBefore: true
          },
        ],
        introduction: {
          title: "Fluency Read",
          subTitle: "Level 9",
          audio: "prompt/l9f-1"
        }
      },
    },
    audioSets: {
      _: [{
        audio: "https://d3vx0tne0vxeo1.cloudfront.net/flaudio/{{lessonId}}/lesson/prompts/{{key}}.mp3",
        prefix: "prompt/",
        data: ["l3-1", "l3-2", "l3f-1", "l3f-2", "l4-1", "l4-2", "l4f-1", "l4f-2", "l5-1", "l5-2", "l5f-1", "l5f-2", "l6-1", "l6-2", "l6f-1", "l6f-2", "l7f-1", "l8f-1", "l9f-1"]
      }]
    },
    review: {
      fromLesson: "self",
      stages: ["prep"]
    },
    data: "lesson28",
    label: 21
  }  
};

// export const soundLessons = [7, 9, 11, 14, 16]
export const soundLessons = []
